/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Error_Heading_Not_IdealInputs */



/**
* | output |
* | --- |
* | "That's not ideal" |
*
* @param {Error_Heading_Not_IdealInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "zh-Hans" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
export const error_heading_not_ideal = /** @type {((inputs?: Error_Heading_Not_IdealInputs, options?: { locale?: "en" | "de" | "fr" | "zh-Hans" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Error_Heading_Not_IdealInputs, { locale?: "en" | "de" | "fr" | "zh-Hans" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Das ist nicht ideal")
	if (locale === "fr") return /** @type {LocalizedString} */ ("Ce n'est pas idéal")
	if (locale === "zh-Hans") return /** @type {LocalizedString} */ ("情况不太妙")
	if (locale === "zh-Hant") return /** @type {LocalizedString} */ ("情況不太妙")
	if (locale === "ko") return /** @type {LocalizedString} */ ("상황이 좋지 않네요")
	return /** @type {LocalizedString} */ ("That's not ideal")
});